import dynamic from 'next/dynamic';
import Banner from './Banner';

export default {
  banner: Banner,
  button: dynamic(() => import(/* webpackChunkName: "blazePbButton" */ './Button')),
  card: dynamic(() => import(/* webpackChunkName: "blazePbCard" */ './Card')),
  carousel: dynamic(() => import(/* webpackChunkName: "blazePbCarousel" */ './Carousel')),
  column: dynamic(() => import(/* webpackChunkName: "blazePbLayout" */ './Layout')),
  datasummary: dynamic(() => import(/* webpackChunkName: "blazePbDataSummary" */ './DataSummary')),
  image: dynamic(() => import(/* webpackChunkName: "blazePbImage" */ './Image')),
  row: dynamic(() => import(/* webpackChunkName: "blazePbLayout" */ './Layout')),
  list: dynamic(() => import(/* webpackChunkName: "blazePbList" */ './List')),
  socialfollow: dynamic(() =>
    import(/* webpackChunkName: "blazePbSocialFollow" */ './SocialFollow')
  ),
  textblock: dynamic(() => import(/* webpackChunkName: "blazePbTextBlock" */ './TextBlock')),
  video: dynamic(() => import(/* webpackChunkName: "blazePbVideo" */ './Video')),
  wrapper: dynamic(() => import(/* webpackChunkName: "blazePbWrapper" */ './Wrapper')),
  searchcontent: dynamic(() =>
    import(/* webpackChunkName: "blazePbSearchFilter" */ './SearchContent/SearchContent')
  ),
  searchfilter: dynamic(() =>
    import(/* webpackChunkName: "blazePbSearchFilter" */ './SearchFilter')
  ),
  searchfiltersort: dynamic(() =>
    import(/* webpackChunkName: "blazePbSearchFilteSort" */ './SearchFilterSort')
  ),
  modal: dynamic(() => import(/* webpackChunkName: "blazePbModal" */ './Modal')),
  datetime: dynamic(() => import(/* webpackChunkName: "blazePbDateTime" */ './DateTime')),
  code: dynamic(() => import(/* webpackChunkName: "blazePbCode" */ './Code')),
  menu: dynamic(() => import(/* webpackChunkName: "blazePbMenu" */ './Menu')),
  menuitem: dynamic(() => import(/* webpackChunkName: "blazePbMenuItem" */ './MenuItem')),
  submenu: dynamic(() => import(/* webpackChunkName: "blazePbSubMenu" */ './SubMenu')),
  emailconfirm: dynamic(() =>
    import(/* webpackChunkName: "blazePbEmailConfirm" */ './EmailConfirm')
  ),

  breadcrumb: dynamic(() => import(/* webpackChunkName: "blazePbBreadcrumb" */ './Breadcrumb')),
  itemlistbutton: dynamic(() =>
    import(/* webpackChunkName: "blazePbItemListButton" */ './ItemList/ItemListButton')
  ),
  itemlistcounter: dynamic(() =>
    import(/* webpackChunkName: "blazePbItemListCounter" */ './ItemList/ItemListCounter')
  ),
  itemlistnew: dynamic(() =>
    import(/* webpackChunkName: "blazePbItemListNew" */ './ItemList/ItemListNew')
  ),
  backtotop: dynamic(() => import(/* webpackChunkName: "blazePbBackToTop" */ './BackToTop')),
  contentgroup: dynamic(() =>
    import(/* webpackChunkName: "blazePbContentGroup" */ './ContentGroup')
  ),
  contentgroupsection: dynamic(() =>
    import(/* webpackChunkName: "blazePbContentGroupSection" */ './ContentGroupSection')
  ),
  iframe: dynamic(() => import(/* webpackChunkName: "blazePbIframe" */ './Iframe'))
};
